import React, { PureComponent } from 'react'
import packageJson from '../../../package.json'

class Footer extends PureComponent {
  render () {
    return (
      <footer>
        &copy;{new Date().getFullYear()} ClubHub <br /> All Rights Reserved <br /> v. {packageJson.version}
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Bone/Footer.js